export const config = {
  staleTime: 300000,
};

export const GET_ALL_PAGE_LIMIT = 1000;
